import { modules } from "@/@core/utils/modules";

export default [
    {
        path: "trabajo-adicional",
        name: "rrhh-trabajo-adicional",
        redirect: { name: "rrhh-trabajo-adicional-solicitudes" },
        component: () => import("@/views/rrhh/views/trabajo-adicional/TrabajoAdicional.vue"),
        meta: {
            module: modules.RRHH,
            section: 30,
            pageTitle: "Trabajos Adicionales",
            breadcrumb: [
                {
                    text: "Pending",
                    active: true,
                },
            ],
            tabs:[
                {
                    title: "Solicitudes",
                    name: "rrhh-trabajo-adicional-solicitudes",
                }
            ]
        },
        children: [
            {
                path: "solicitudes",
                name: "rrhh-trabajo-adicional-solicitudes",
                component: () => import("@/views/rrhh/views/trabajo-adicional/components/TrabajoAdicionalTable.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 30,
                    pageTitle: "Solicitudes de Trabajo Adicional",
                    breadcrumb: [
                        {
                            text: "Solicitudes",
                            active: true,
                        },
                    ],
                },
            }
        ]
    }
]